import { Link } from 'react-router-dom';
import type { ActivitySubjectActionSummary, ActivitySubjectCard } from '@shared/types/activity-feed';
import type { LightViewAction } from '@shared/types/views';
import { buildSubjectThreadPath } from '@/lib/thread-routes';
import { getSubjectWorkActions } from '@/lib/work-actions';
import { WorkActionCard } from '@/components/work/WorkActionCard';
export type ActivityActionTriageReason = 'already_done' | 'not_relevant' | 'later';
type ToolHandoffAction = Extract<LightViewAction, { type: 'tool_handoff' }>;
type FlowHandoffAction = Extract<LightViewAction, { type: 'flow_handoff' }>;

export type ActivityLaunchTone = 'running' | 'blocked' | 'done' | 'failed' | 'neutral';

export interface ActivityActionLaunchStatus {
  label: string;
  href: string | null;
  tone: ActivityLaunchTone;
}

interface ActivityActionQueueProps {
  subjects: ActivitySubjectCard[];
  onTriageAction: (
    subject: ActivitySubjectCard,
    action: ActivitySubjectActionSummary,
    reason: ActivityActionTriageReason
  ) => void;
  onToolHandoff: (
    subject: ActivitySubjectCard,
    action: ActivitySubjectActionSummary,
    toolAction: ToolHandoffAction
  ) => void;
  onFlowHandoff: (
    subject: ActivitySubjectCard,
    action: ActivitySubjectActionSummary,
    flowAction: FlowHandoffAction
  ) => void;
  onPreparePlan: (sourceRunId: string) => void;
  preparingPlanSourceRunId: string | null;
  triagingActionId: string | null;
  launchStatuses: Record<string, ActivityActionLaunchStatus>;
}

export const getActivityActionTriageId = (
  subject: ActivitySubjectCard,
  action: ActivitySubjectActionSummary
): string =>
  `${subject.subjectId ?? subject.subjectKey ?? `${subject.subjectKind}:${subject.subjectLabel}`}:${action.id}`;


export const ActivityActionQueue = ({subjects,onTriageAction,triagingActionId}: ActivityActionQueueProps) => <section aria-label="Actions des comptes">
  {subjects.map(subject => {
    const [primary,...others] = getSubjectWorkActions(subject);
    if (!primary) return null;
    const source = subject.recommendedActions.find(a => a.sourceRunId === primary.context.sourceRunId && a.sourceActionId === primary.context.sourceActionId);
    return <article key={subject.subjectId} className="border-t border-domino-cardBorder py-5">
      <Link to={buildSubjectThreadPath(subject)} className="mb-3 inline-block text-base font-semibold text-domino-aubergine">{subject.subjectLabel}</Link>
      <WorkActionCard work={primary} compact />
      {source?.dismissible && <details className="mt-3"><summary className="cursor-pointer text-sm text-domino-inkSoft">Autres choix</summary><div className="mt-2 flex flex-wrap gap-4">{([['already_done','Déjà fait'],['not_relevant','Pas pertinent'],['later','Plus tard']] as const).map(([reason,label]) => <button key={reason} className="text-sm underline" disabled={triagingActionId === getActivityActionTriageId(subject,source)} onClick={() => onTriageAction(subject,source,reason)}>{label}</button>)}</div></details>}
      {others.length>0 && <details className="mt-5"><summary className="cursor-pointer text-sm font-medium">{others.length} autres sujets</summary>{others.map(work => <div key={work.id} className="mt-4 border-t border-domino-cardBorder pt-4"><WorkActionCard work={work} compact /></div>)}</details>}
    </article>;
  })}
</section>;
